import { render, staticRenderFns } from "./InformationRegistration.vue?vue&type=template&id=47a7305e&scoped=true"
import script from "./InformationRegistration.vue?vue&type=script&lang=js"
export * from "./InformationRegistration.vue?vue&type=script&lang=js"
import style0 from "./InformationRegistration.vue?vue&type=style&index=0&id=47a7305e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a7305e",
  null
  
)

export default component.exports